import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    boxContainer: {
        flex: '1 0 auto',
        height: '100%',
        display: 'flex',
        outline: '0',
        overflowY: 'auto',
        flexDirection: 'column',
        '-webkit-overflow-scrolling': 'touch',
        padding: theme.spacing(1),
    },
    cardContentRoot: {
        padding: '5px',
        '&:last-child': {
            paddingBottom: '5px',
        },
    }
}))